export default { sha: '59580b4a19602a297d56f007058004d24ca14b75', buildNumber: 'undefined' }
